import * as React from 'react'
import { useParams, useLocation } from 'react-router-dom'
import DI from '../../app/di'
import Loader from '../../components/Loader'
import { ICreativeService } from '../../interfaces/services/creatives'
import { translateWithUserLocale } from '../../utils/i18n'
import CreativePreview from '../CreativeDetails/CreativePreview'

import { Box, Typography, styled } from '@design/pt-ui'
import { Creative } from '../../interfaces/entities/creative'
import { doHttp } from '../../utils/json-api'
import CreativePreviewNative from '../CreativeDetails/CreativePreviewNative'

const Root = styled('div')({
  marginTop: 20,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

const Main = () => {
  const { id } = useParams()
  const location = useLocation()
  const [creative, setCreative] = React.useState<Creative | null>(null)
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState('')
  const [publicRoute, setPublicRoute] = React.useState(false)

  React.useEffect(() => {
    checkStatus()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getCreativeService = () => {
    return DI.get('CreativeService') as ICreativeService
  }

  const checkStatus = async () => {
    const text = location.search.slice(14)
    const decoded = atob(text)
    try {
      const res = await doHttp({
        method: 'get',
        url: decoded,
      })
      if (res.status) {
        setError('')
        loadCreative()
      } else {
        setError(res.message)
      }
    } catch (e) {
      setError('Error has occured.')
    }
  }

  const loadCreative = async () => {
    if (!id) {
      return
    }
    setLoading(true)

    const response = await getCreativeService().getCreativeForPreview(id)
    if (response.type === 'error') {
      return
    } else {
      setCreative(response.payload.creative)
      setPublicRoute(response.payload.public)
    }
    setLoading(false)
  }

  if (loading) {
    return (
      <Loader message={translateWithUserLocale('loaders.loading_creative')} />
    )
  }

  if (error) {
    return (
      <Root>
        <Typography variant="h5">{error}</Typography>
      </Root>
    )
  }

  return (
    <Root>
      {creative && (
        <>
          <Typography variant="h5">{creative.name}</Typography>
          <Box sx={{ marginTop: '20px' }}>
            {creative.project?.formatsets[0].type === 'facebook' && (
              <CreativePreview creative={creative} preview={true} />
            )}
            {creative.project?.formatsets[0].type ===
              'performance_advertising' && (
              <CreativePreviewNative
                creative={creative}
                preview={true}
                publicRoute={publicRoute}
              />
            )}
          </Box>
        </>
      )}
    </Root>
  )
}

export default Main
